interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="https://public.readdy.ai/ai/img_res/ae5459f1-d3db-4325-ac3a-08ac7b19695d.png" 
              alt="Independence Medical Equipment Logo" 
              className="h-12 w-auto object-contain"
            />
            <span className={`font-bold text-lg ${scrolled ? 'text-[#1e3a5f]' : 'text-white'}`}>
              Independence Medical Equipment
            </span>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('service-overview')}
              className={`font-medium hover:text-[#14B8A6] transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('areas-served')}
              className={`font-medium hover:text-[#14B8A6] transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Service Areas
            </button>
            <button 
              onClick={() => scrollToSection('faq-section')}
              className={`font-medium hover:text-[#14B8A6] transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              FAQs
            </button>
            <button 
              onClick={() => scrollToSection('about-us')}
              className={`font-medium hover:text-[#14B8A6] transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About Us
            </button>
          </div>

          {/* Request Repair Button */}
          <button 
            onClick={() => scrollToSection('request-form')}
            className="bg-[#14B8A6] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#0f9b8e] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Request Repair
          </button>
        </div>
      </div>
    </nav>
  );
}